import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootPrintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_footprint_generic_json_shipment_contentsService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { shipmentId: number, orderId?: number, typeId: number }): Promise<{ result?: { ShipmentId?: number, ShipmentLineId?: number, OrderId?: number, OrderLineNumber?: number, LicensePlateId?: number, LotId?: number, PackagedId?: number, PackagedAmount?: number, LicensePlate?: { Id?: number, DimensionsUomId?: number, GrossVolume?: number, GrossWeight?: number, Height?: number, Length?: number, LookupCode?: string, MaximumWeight?: number, NetVolume?: number, NetWeight?: number, VolumeUomId?: number, WeightUomId?: number, Width?: number, ShippingContainer?: { Id?: number, BillOfLading?: string, BondNumber?: string, CommodityDescription?: string, ContainerNumber?: string, CustomsReleaseNumber?: string, DeclaredValue?: number, EstimatedDeliveryDateTime?: string, Height?: number, Length?: number, LookupCode?: string, ManifestedPackageBundleCode?: string, ManifestedPackageCode?: string, NmfcNumber?: string, NmfcSubNumber?: string, Notes?: string, PackagedItemCount?: number, SailOnBoard?: string, SealId?: string, ShippingCost?: number, ShippingDate?: string, TrackingNumber?: string, TrailerNumber?: string, Volume?: number, Weight?: number, Width?: number, Carrier?: { Name?: string, ScacCode?: string, ShortName?: string }, CarrierServiceType?: { Name?: string, ShortName?: string }, DimensionUom?: { Short_name?: string }, FreightClass?: { Name?: string }, ContainerSize?: { Name?: string }, ContainerType?: { Name?: string }, VolumeUom?: { Short_name?: string }, WeightUom?: { Short_name?: string } }, Location?: { Name?: string, Status?: { Name?: string } }, Status?: { Name?: string } }, Lot?: { Id?: number, Description?: string, LastReceiveDate?: string, LookupCode?: string, Notes?: string, ReceiveDate?: string, VendorLot?: { Id?: number, Description?: string, ExpirationDate?: string, ExpirationNotificationDateOverride?: string, ExpirationNotificationOverride?: boolean, LookupCode?: string, ManufactureDate?: string, Notes?: string, Vat?: string }, Material?: { Id?: number, PackagingLookups?: { PackagingId?: number, BasePackagingQuantity?: number, SubPackagingQuantity?: number }[] }, Status?: { Name?: string } }, Packaging?: { Id?: number, Name?: string, ShortName?: string } }[], totalCount?: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shipmentId)) {
      missingRequiredInParams.push('\'shipmentId\'');
    }
    if (isNil(inParams.typeId)) {
      missingRequiredInParams.push('\'typeId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

